import { useState, useEffect, useCallback } from 'react';
import { api } from './components/api';

export const useFetchMovies = (callType) => {
  const [movies, setMovies] = useState([]);
  const [trending, setTrending] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [heroHome, setHeroHome] = useState([]);
  const [trailers, setTrailers] = useState([]);

  const fetchMovies = useCallback(async () => {
    setIsLoading(true);
    try {
      // Get popular movies
      const resp = await fetch(
        `${api.url}${api.discover}?api_key=${api.apiKey}`
      );
      const data = await resp.json();

      // getTrending movies
      const trendResp = await fetch(
        `${api.url}${api.trending}?api_key=${api.apiKey}`
      );
      const trendData = await trendResp.json();

      setMovies(data.results);
      setTrending(trendData.results);

      // grab 4 random objects from the trendDate.results for the hero carousel
      const movieTrailers = [];
      for (let i = 0; i < 4; i++) {
        const trailerFetch = async () => {
          const { id } = trendData.results[i];

          try {
            const resp = await fetch(
              `${api.url}${api.movie}/${id}?api_key=${api.apiKey}&append_to_response=videos,images`
            );

            let video;
            const movie = await resp.json();
            if (movie.videos.results[0]) {
              video = movie.videos.results[0].key;
            } else {
              video = null;
            }

            const movieData = {
              id: movie.id,
              title: movie.title,
              backdrop_path: movie.backdrop_path,
              overview: movie.overview,
              video,
              thumb: movie.images.backdrops[1].file_path,
            };

            if (movieData.video) {
              movieTrailers.push(movieData);
            }
          } catch (error) {
            // console.log('ERROR IN TRAILERS');
            return;
          }
        };
        trailerFetch();
      }

      // grab 4 random objects from the data.results for the hero carousel
      const heros = [];
      for (let i = 0; i < 4; i++) {
        const rand = Math.floor(Math.random() * data.results.length);

        heros.push(data.results[rand]);
      }

      setHeroHome(heros);
      setTrailers(movieTrailers);

      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.log('ERROR: ', error);
    }
  }, []);

  // grab data from api
  useEffect(() => {
    fetchMovies();
  }, [fetchMovies]);

  return { movies, trending, heroHome, trailers, isLoading };
};
